import { render, staticRenderFns } from "./passwordRequest.vue?vue&type=template&id=15c3cf86&scoped=true"
import script from "./passwordRequest.vue?vue&type=script&lang=js"
export * from "./passwordRequest.vue?vue&type=script&lang=js"
import style0 from "./passwordRequest.vue?vue&type=style&index=0&id=15c3cf86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c3cf86",
  null
  
)

export default component.exports